// extracted by mini-css-extract-plugin
export default {"container":"profile-page_container__PC5jW","wrapper":"profile-page_wrapper__zhjL3"};